import * as React from "react";
import { ARROW_LEFT } from '../assets'

export class ScrollView extends React.Component {
    private scrollView: HTMLDivElement | null
    private scrollRequestCode: number = 0;

    state = {
        leftHidden: true,
        rightHidden: false
    }

    componentDidMount() {
        if (this.scrollView) {
            if (this.scrollView.scrollWidth <= this.scrollView.clientWidth) {
                this.setState({ rightHidden: true })
            }
        }
    }

    render() {
        const { rightHidden, leftHidden } = this.state
        return <div className={"scrollview-container"}>
            <div className="arrow-container left" style={leftHidden ? { display: 'none' } : {}} onClick={() => { this.scrollView && this.scrollElements(this.scrollView, -200, 500) }}>
                <img src={ARROW_LEFT} alt={'arrow_left'} />
            </div>
            <div ref={(element) => this.scrollView = element} className={"scroll-container"} onScroll={() => {
                if (this.scrollView!.scrollLeft > 10) {
                    leftHidden && this.setState({ leftHidden: false })
                } else if (!leftHidden) {
                    this.setState({ leftHidden: true })
                }
                if (this.scrollView!.scrollLeft > (this.scrollView!.scrollWidth - this.scrollView!.clientWidth - 5)) {
                    !rightHidden && this.setState({ rightHidden: true })
                } else if (rightHidden) {
                    this.setState({ rightHidden: false })
                }
            }}>
                {this.props.children}
            </div>
            <div className="arrow-container right" style={rightHidden ? { display: 'none' } : {}} onClick={() => { this.scrollView && this.scrollElements(this.scrollView, 200, 500) }}>
                <img src={ARROW_LEFT} alt={'arrow-right'} />
            </div>
        </div>
    }

    private scrollElements(element: HTMLDivElement, offset: number, duration: number) {
        var start = element.scrollLeft;
        var currentTime = 0;
        var increment = 20;
        offset = this.getNewOffset(start, offset)

        let _requestCode = ++this.scrollRequestCode;
        var animateScroll = () => {
            if (_requestCode !== this.scrollRequestCode) {
                return;
            }

            currentTime += increment;
            var val = this.easeInOutQuad(currentTime, start, offset, duration);
            element.scrollLeft = val;
            //this.setArrows(element.scrollLeft)
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }

    private getNewOffset(start: number, offset: number): number {
        let rest = start % offset
        return rest < Math.abs(offset) / 2 ? offset - rest : (offset - rest) + Math.abs(offset)
    }

    private easeInOutQuad(currentTime: number, startValue: number, offset: number, duration: number) {		//https://stackoverflow.com/questions/52747018/horizontal-scrolling-using-buttons-in-reactjs
        currentTime /= duration / 2;
        if (currentTime < 1) {
            return offset / 2 * currentTime * currentTime + startValue;
        }
        currentTime--;
        return -offset / 2 * (currentTime * (currentTime - 2) - 1) + startValue;
    }
}


// WEBPACK FOOTER //
// ./src/components/ScrollView.tsx